import axios from "axios";
import { DEFAULT_LANG, getCurrentLang } from "../i18n/core";

export const API_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token (fallback to cookie if not set) + current site language for public reads
api.interceptors.request.use((config) => {
  const url = config.url || "";
  const lang = getCurrentLang();
  const isPublicRead = (config.method || "get") === "get" && !url.startsWith("/admin") && !url.startsWith("/auth");
  if (isPublicRead && lang !== DEFAULT_LANG && !(config.params && "lang" in config.params)) {
    config.params = { ...(config.params || {}), lang };
  }
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function resolveImage(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (
    url.startsWith("/api/uploads/") ||
    url.startsWith("/uploads/") ||
    url.startsWith("/api/media/") ||
    url.startsWith("/media/")
  ) {
    return `${API_URL}${url}`;
  }
  return url;
}
